<template>
  <div class="message">
    <avatar class="image" :image="message.sender.image" />
    <div class="content">
      <span class="message-sender-text">{{ message.sender.first_name }} {{ message.sender.last_name }}</span>
      <span class="message-time">{{ displayCreated }}</span>
      <div class="message-content">{{message.payload.message}}</div>
    </div>
  </div>
</template>

<script>
import avatar from "@/components/userImg";
import moment from "moment";

export default {
  props: ["message"],
  components: { avatar },
  computed: {
    displayCreated() {
      const now = moment();
      const created = moment(this.message.created_at);
      if (now.date() === created.date()) {
        return created.format("LT");
      } else if (now.year() === created.year()) {
        return created.format("D MMM LT");
      }
      return moment(this.message.created_at).format("ll LT");
    }
  }
};
</script>

<style lang="less">
.message {
  display: flex;
  flex-direction: row;

  .content {
    padding-left: 5px;
  }

  .messages-container {
    display: flex;
    /*flex-grow: 1;*/
    flex-direction: column;
    justify-content: flex-end;
    overflow-y: auto;
  }
  img {
    height: 35px;
    width: 35px;
  }
  .message-time {
    padding-left: 10px;
    font-size: 12px;
    opacity: 0.5;
    font-weight: 600;
  }

  .message-sender-text {
    font-size: 16px;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: left;
    color: #000000;
  }

  .message-content {
    margin-bottom: 12px;
  }
}
</style>
